(() => {
  if (window.bqBuyNowReady) return;
  window.bqBuyNowReady = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const fallbackSubmit = form => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'return_to';
    input.value = '/checkout';
    form.appendChild(input);
    HTMLFormElement.prototype.submit.call(form);
  };

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-bq-buy-now]');
    if (!button) return;
    const form = button.closest('form');
    if (!form) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    const variantId = form.querySelector('input[name="id"]').value;
    try {
      // Exactly one copy in the cart, then straight to checkout.
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: { [variantId]: 1 } })
      });
      if (!response.ok) throw new Error('cart update failed');
      window.location.href = root + 'checkout';
    } catch (error) {
      fallbackSubmit(form);
    }
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-bq-buy-now][aria-busy]').forEach(button => button.removeAttribute('aria-busy'));
  });
})();
